var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsdLeftHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 350,
    viewBox: "0 0 347 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3294 191.913C61.3053 189.94 51.0387 176.4 51.0387 176.4C51.0387 176.4 51.3996 169.976 52.1134 168.211C52.8273 166.446 55.3138 164.602 56.8778 163.856C58.4419 163.11 61.9952 163.142 61.9952 163.142C61.9952 163.142 61.6342 175.662 61.8428 176.866C62.0513 178.069 63.3267 178.349 63.3267 178.349H60.1022C64.1688 184.67 72.3421 191.913 72.3421 191.913L73.9302 192.53C73.9302 192.53 74.4436 199.236 73.473 201.281C72.5025 203.326 65.3078 206.07 65.0271 206.302C64.7463 206.535 64.2089 205.997 64.2089 205.997L63.7999 196.629L61.3294 191.913ZM61.3294 191.913C58.2815 194.295 54.7924 198.009 54.7924 198.009C44.8946 218.285 48.0308 257.532 48.0308 257.532H53.1481C53.1481 257.532 52.0573 262.071 52.0573 262.039C52.0573 262.007 47.0041 262.039 47.0041 262.039C47.0041 262.039 43.868 268.729 44.0043 287.49C44.1407 306.25 54.1106 328.115 54.1106 328.115H93.8381C93.8381 328.115 83.1863 311.28 83.5954 295.599C84.0045 279.918 87.7262 267.806 90.2207 262.994H83.1863C83.1863 262.994 77.1466 269.242 76.152 284.225C75.1655 299.208 76.5611 312.555 76.5611 312.555C76.5611 312.555 51.4637 306.756 44.9508 298.013",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1561 257.532H87.4935L83.1942 262.994L52.0652 262.031",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4935 257.532C87.4935 257.532 105.974 228.52 146.27 239.781M162.24 157.046C162.24 157.046 129.763 157.688 67.6177 187.365",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.271 239.781L152.206 242.958H188.966L177.801 228.007L177.191 199.741L178.314 175.173L177.905 162.572L179.645 157.046H162.24",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.342 99.4082H181.009C181.009 99.4082 177.873 99.5766 177.873 102.344C177.873 105.111 177.873 155.201 177.873 155.201L179.645 157.046L192.342 156.701V99.4082Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.009 99.4082C181.009 99.4082 175.242 98.7264 175.274 102.825C175.306 106.924 175.274 151.728 175.274 151.728L177.865 155.209",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.411 157.046L175.282 151.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.646 157.046L182.645 168.925C182.645 168.925 187.185 173.184 193.498 170.457C199.81 167.73 194.933 164.209 194.933 164.209L193.554 161.859L190.562 156.757",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.314 175.174L207.43 171.725C206.475 168.171 195.824 161.859 195.824 161.859H193.554",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.865 161.851H178.314",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.206 242.958C152.206 242.958 163.403 247.153 172.21 260.949C181.017 274.737 180.263 291.26 180.263 291.26V328.124H482.803V234.456H494V-2L422.598 0.24585C422.598 0.24585 354.196 4.95411 299.317 26.1212C244.438 47.2883 221.563 80.6632 221.563 80.6632L203.62 106.138L192.343 124.217",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.408 0.414062L432.151 62.4315H246.925C246.925 62.4315 241.743 62.8085 236.449 70.5086",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.541 234.937H281.021",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.529 245.204H313.514C313.514 245.204 315.014 235.972 317.709 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.556 234.937C332.556 234.937 336.037 238.955 336.037 245.212H428.461L431.533 234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.514 245.204L314.677 260.941C314.677 260.941 315.904 265.24 317.717 265.312C319.53 265.384 331.746 265.312 331.746 265.312C331.746 265.312 334.24 264.598 335.026 260.74C335.812 256.882 336.053 245.212 336.053 245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.722 244.153L319.385 261.149H330.101L333.237 244.153L331.056 237.6H318.832L316.722 244.153Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.237 244.153H336.037",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.723 244.153H313.514",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 269.275C176.5 269.275 176 269.275 185.998 269.275H308.052V245.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.052 269.274V328.116",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.052 304.494L192.343 305.312V297.123H308.052H482.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.369 245.204C193.369 245.204 199.24 254.115 201.013 262.031H308.052H315.046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.392 262.032V245.204L281.021 234.937H182.974",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 336.289C156.568 336.289 176.958 315.899 176.958 290.746C176.958 265.594 156.568 245.204 131.416 245.204C106.263 245.204 85.8733 265.594 85.8733 290.746C85.8733 315.899 106.263 336.289 131.416 336.289Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 316.493C145.636 316.493 157.163 304.966 157.163 290.746C157.163 276.526 145.636 264.999 131.416 264.999C117.196 264.999 105.669 276.526 105.669 290.746C105.669 304.966 117.196 316.493 131.416 316.493Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 332.278C154.353 332.278 172.948 313.684 172.948 290.746C172.948 267.808 154.353 249.214 131.416 249.214C108.478 249.214 89.8838 267.808 89.8838 290.746C89.8838 313.684 108.478 332.278 131.416 332.278Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 312.868C143.633 312.868 153.538 302.964 153.538 290.746C153.538 278.529 143.633 268.625 131.416 268.625C119.199 268.625 109.294 278.529 109.294 290.746C109.294 302.964 119.199 312.868 131.416 312.868Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 297.941C135.389 297.941 138.611 294.72 138.611 290.746C138.611 286.772 135.389 283.551 131.416 283.551C127.442 283.551 124.221 286.772 124.221 290.746C124.221 294.72 127.442 297.941 131.416 297.941Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.855 72.1289L192.343 153.356",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.174 73.1796H295.146C295.146 73.1796 302.91 71.5835 306.576 79.0028C306.576 79.0028 306.833 109.787 302.485 122.5C302.485 122.5 301.804 129.582 292.596 131.203C283.388 132.823 226.584 136.488 226.584 136.488C226.584 136.488 218.226 136.745 217.881 130.858L222.662 106.466",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.693 101.766C225.693 101.766 221.033 116.316 220.44 130.088C220.44 130.088 219.926 134.307 224.105 134.355C224.105 134.355 280.692 131.58 292.331 128.941C292.331 128.941 297.961 128.644 300.689 120.623C300.689 120.623 305.252 89.2778 304.442 80.9682C304.442 80.9682 304.571 77.1342 298.146 74.6558H243.147",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.031 199.645C260.031 199.645 265.742 194.528 273.498 199.645L272.624 219.152L266.76 221.919L260.897 219.152L260.031 199.645Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.268 203.022H265.196V219.505H268.268V203.022Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.196 204.762L262.229 206.398V217.612H265.509",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.268 204.762L271.396 206.35V217.612H268.268",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76 201.899C267.792 201.899 268.629 201.062 268.629 200.03C268.629 198.998 267.792 198.161 266.76 198.161C265.728 198.161 264.891 198.998 264.891 200.03C264.891 201.062 265.728 201.899 266.76 201.899Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.43 234.456L209.339 240.07H286.853H314.717",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.235 240.07H430.001",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3266 178.341H65.9574C65.9574 178.341 67.0483 178.133 67.2167 176.906C67.3852 175.679 67.2167 164.923 67.2167 164.923C67.2167 164.923 67.3691 163.27 65.4762 163.134C63.5833 162.997 61.9951 163.134 61.9951 163.134",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1022 178.342H57.2869C57.2869 178.342 56.3645 178.623 57.2869 179.978C58.2093 181.334 71.0106 196.87 71.0106 196.87C71.0106 196.87 72.31 198.129 71.9411 202.773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.263 314.015H482.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 277.343C133.263 277.343 134.761 275.846 134.761 273.999C134.761 272.151 133.263 270.654 131.416 270.654C129.569 270.654 128.071 272.151 128.071 273.999C128.071 275.846 129.569 277.343 131.416 277.343Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.629 294.091C150.476 294.091 151.973 292.593 151.973 290.746C151.973 288.899 150.476 287.401 148.629 287.401C146.781 287.401 145.284 288.899 145.284 290.746C145.284 292.593 146.781 294.091 148.629 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.716 294.091C116.564 294.091 118.061 292.593 118.061 290.746C118.061 288.899 116.564 287.401 114.716 287.401C112.869 287.401 111.372 288.899 111.372 290.746C111.372 292.593 112.869 294.091 114.716 294.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.416 310.838C133.263 310.838 134.761 309.341 134.761 307.494C134.761 305.646 133.263 304.149 131.416 304.149C129.569 304.149 128.071 305.646 128.071 307.494C128.071 309.341 129.569 310.838 131.416 310.838Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.677 305.312C144.524 305.312 146.022 303.815 146.022 301.967C146.022 300.12 144.524 298.623 142.677 298.623C140.83 298.623 139.333 300.12 139.333 301.967C139.333 303.815 140.83 305.312 142.677 305.312Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.882 283.199C121.729 283.199 123.227 281.701 123.227 279.854C123.227 278.007 121.729 276.509 119.882 276.509C118.035 276.509 116.537 278.007 116.537 279.854C116.537 281.701 118.035 283.199 119.882 283.199Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.487 283.199C145.335 283.199 146.832 281.701 146.832 279.854C146.832 278.007 145.335 276.509 143.487 276.509C141.64 276.509 140.143 278.007 140.143 279.854C140.143 281.701 141.64 283.199 143.487 283.199Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.882 304.983C121.729 304.983 123.227 303.486 123.227 301.639C123.227 299.791 121.729 298.294 119.882 298.294C118.035 298.294 116.537 299.791 116.537 301.639C116.537 303.486 118.035 304.983 119.882 304.983Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.855 72.1289L248.36 66.7549L246.933 66.7629C246.933 66.7629 239.898 66.4581 236.457 70.5167L192.351 134.66",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.352 66.7471H300.344C304.603 66.7471 308.052 70.196 308.052 74.4551V234.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.344 66.7471C300.344 66.7471 310.097 67.0599 310.506 72.0168C310.915 76.9737 310.506 234.929 310.506 234.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.964 56.4963C252.964 56.4963 292.604 28.0623 339.999 18.2046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.414 335.414C158.633 336.195 157.367 336.195 156.586 335.414L143.858 322.686C143.077 321.905 143.077 320.639 143.858 319.858C144.639 319.077 145.905 319.077 146.687 319.858L158 331.172L169.314 319.858C170.095 319.077 171.361 319.077 172.142 319.858C172.923 320.639 172.923 321.905 172.142 322.686L159.414 335.414ZM156.586 222.086C157.367 221.305 158.633 221.305 159.414 222.086L172.142 234.814C172.923 235.595 172.923 236.861 172.142 237.642C171.361 238.423 170.095 238.423 169.314 237.642L158 226.328L146.687 237.642C145.905 238.423 144.639 238.423 143.858 237.642C143.077 236.861 143.077 235.595 143.858 234.814L156.586 222.086ZM156 334L156 223.5L160 223.5L160 334L156 334Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 336.5,
    x2: 347,
    y2: 336.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 251C49 251 49.6737 237.05 53.69 228.574C57.715 220.099 64.5225 219.607 70 219L63.2975 234.996L49 251Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 205C145 203.895 145.895 203 147 203H169C170.105 203 171 203.895 171 205V219C171 220.105 170.105 221 169 221H147C145.895 221 145 220.105 145 219V205ZM157.527 219.677H158.476C158.712 219.677 158.903 219.485 158.903 219.25V215.752C158.903 215.517 158.712 215.325 158.476 215.325H157.527C157.291 215.325 157.099 215.517 157.099 215.752V219.25C157.099 219.485 157.291 219.677 157.527 219.677ZM158.476 208.681H157.527C157.291 208.681 157.099 208.489 157.099 208.249V204.752C157.099 204.516 157.291 204.325 157.527 204.325H158.476C158.712 204.325 158.903 204.516 158.903 204.752V208.254C158.903 208.489 158.712 208.681 158.476 208.681ZM150.738 212.903H154.244C154.48 212.903 154.672 212.712 154.672 212.476V211.529C154.672 211.294 154.48 211.103 154.244 211.103H150.738C150.502 211.103 150.31 211.294 150.31 211.529V212.476C150.31 212.712 150.502 212.903 150.738 212.903ZM161.332 212.472V211.525C161.332 211.289 161.523 211.098 161.759 211.098H165.266C165.502 211.098 165.693 211.289 165.693 211.525V212.472C165.693 212.707 165.502 212.898 165.266 212.898H161.759C161.523 212.898 161.332 212.707 161.332 212.472ZM152.225 217.094L152.898 217.765C153.067 217.934 153.339 217.934 153.504 217.765L155.985 215.29C156.155 215.121 156.155 214.85 155.985 214.685L155.313 214.014C155.143 213.845 154.872 213.845 154.707 214.014L152.225 216.49C152.06 216.654 152.06 216.925 152.225 217.094ZM161.3 209.988C161.136 210.157 160.864 210.157 160.694 209.988L160.022 209.317C159.852 209.152 159.852 208.881 160.022 208.712L162.503 206.237C162.668 206.068 162.94 206.068 163.109 206.237L163.782 206.908C163.951 207.072 163.951 207.343 163.782 207.512L161.3 209.988Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdLeftHeight);
export default __webpack_public_path__ + "static/media/bsdLeftHeight.9a1c60f9df9c875829e2a3603fda28d8.svg";
export { ForwardRef as ReactComponent };